import * as React from 'react';

import { Button, Flex, Input, Typography } from 'antd';

import { AntdRouterLink, PlusOutlinedIcon } from 'components';
import { PATHNAME } from 'utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    ATTRIBUTES: { CREATE_URL: ATTRIBUTES_CREATE_URL },
  },
} = PATHNAME;

type AttributesHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
};

const AttributesHeader = ({
  searchKey,
  handleSearchKey,
  children,
}: React.PropsWithChildren<AttributesHeaderProps>) => (
  <Flex
    gap='small'
    className='mb-5 max-lg:flex-col lg:items-center lg:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-lg'>
      فیلد‌ها
    </Typography.Title>
    <Flex gap='small' className='max-lg:flex-wrap'>
      <Input.Search
        allowClear
        styles={{
          affixWrapper: {
            height: '2.5rem',
          },
        }}
        placeholder='جستجوی فیلد‌ها'
        defaultValue={searchKey}
        onSearch={value => handleSearchKey(value)}
      />
      <React.Fragment>{children}</React.Fragment>
      <AntdRouterLink
        to={`${ATTRIBUTES_CREATE_URL}${DEFAULT_SLUG_SEPARATOR}`}
        className='max-lg:basis-full'
      >
        <Button type='primary' className='w-full' icon={<PlusOutlinedIcon />}>
          افزودن فیلد
        </Button>
      </AntdRouterLink>
    </Flex>
  </Flex>
);

export { AttributesHeader };
